import React, {useEffect, useState} from 'react'
import {dataAniversarioFields} from "./data-aniversario-fields"
import {Paper} from "@mui/material"
import DynamicColumnTable from "../../../componentes/dynamic-column-table"
import PropTypes from "prop-types"
import {copyTable, pasteTableFromClipboard} from "../../../../utils/csv-utils"

const DataAniversarioTable = (
    {
        tableData,
        setTableData,
        clearTable
    }) => {
    const [tableKey, setTableKey] = useState(Math.random() * 10)

    useEffect(() => {
        setTableKey(Math.random() * 10) // todo: remover
    }, [])

    return <Paper sx={{mt: 2}}>
        <DynamicColumnTable
            key={tableKey}
            actionButtons={true}
            copyData={() => copyTable(tableData, dataAniversarioFields)}
            pasteData={async () => await pasteTableFromClipboard(dataAniversarioFields, setTableData)}
            clearTable={() => clearTable(setTableData)}
            fields={dataAniversarioFields}
            items={tableData}
            setItems={setTableData}
        />
    </Paper>
}

DataAniversarioTable.propTypes = {
    tableData: PropTypes.array,
    setTableData: PropTypes.func,
    clearTable: PropTypes.func,
}

export default DataAniversarioTable